const isModifiedClickEvent = (e) => e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
export {
  isModifiedClickEvent
};
//# sourceMappingURL=is-modified-click-event.js.map
